import React from 'react';
import { trashIcon } from '@chordbaker/design';

interface TrashIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number;
  color?: string;
}

const TrashIcon: React.FC<TrashIconProps> = ({ size = 16, color = 'currentColor', ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill={trashIcon.fill}
    viewBox={trashIcon.viewBox}
    strokeWidth={trashIcon.strokeWidth}
    stroke={color}
    width={size}
    height={size}
    {...props}
  >
    <path
      strokeLinecap={trashIcon.strokeLinecap as React.SVGAttributes<SVGPathElement>['strokeLinecap']}
      strokeLinejoin={trashIcon.strokeLinejoin as React.SVGAttributes<SVGPathElement>['strokeLinejoin']}
      d={(trashIcon.elements[0] as { d: string }).d}
    />
  </svg>
);

export default TrashIcon;
